import { Loader2 } from 'lucide-react';

interface TenantPortalVideoLoadingSkeletonProps {
  aspectClass?: string;
  className?: string;
  /** Fills a sized parent (player shell) instead of establishing aspect ratio. */
  overlay?: boolean;
}

/**
 * YouTube-style load state: solid black 16:9 (or overlay) with a centered spinner.
 */
export default function TenantPortalVideoLoadingSkeleton({
  aspectClass = 'aspect-video',
  className = '',
  overlay = false,
}: TenantPortalVideoLoadingSkeletonProps) {
  const spinner = (
    <div className="flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-white/90" strokeWidth={1.5} aria-hidden="true" />
    </div>
  );

  if (overlay) {
    return (
      <div
        className={`absolute inset-0 z-30 flex items-center justify-center bg-black ${className}`.trim()}
        aria-busy="true"
        aria-label="Loading video"
      >
        {spinner}
      </div>
    );
  }

  return (
    <div
      className={`relative w-full shrink-0 self-stretch overflow-hidden rounded-xl border border-gray-200 bg-black dark:border-white/10 ${aspectClass} ${className}`.trim()}
      aria-busy="true"
      aria-label="Loading video"
    >
      <div className="absolute inset-0 flex items-center justify-center bg-black">{spinner}</div>
    </div>
  );
}
